import { gql } from "@apollo/client";
import { ResourceCategoryFragment } from "../../fragments/resource";

export const QUERY_FETCH_RESOURCE_CATEGORIES = gql`
  query resourceCategories {
    resourceCategories {
      ...ResourceCategoryFragment
    }
  }
  ${ResourceCategoryFragment}
`;

export const QUERY_FETCH_RESOURCE_CATEGORY_BY_ID = gql`
  query resourceCategory($documentId: ID!) {
    resourceCategory(documentId: $documentId) {
      ...ResourceCategoryFragment
    }
  }
  ${ResourceCategoryFragment}
`;
